<script>

export default {
  name: 'CarFeature',

  props: {
    feature: {
      type: Object,
      required: true
    }
  },

  computed: {
    printableValue () {
      return this.feature.value !== true
    },

    translatedValue () {
      if (typeof this.feature.value == 'number') {
        return this.feature.value
      }
      return this.$t(`cars.feature_values.${this.feature.name}.${this.feature.value}`)
    }
  }

}
</script>

<template>
  <div class="car-feature columns" v-if="feature && feature.value != undefined">
    <div class="inner">
      <div class="icon">
        <svg-icon :name="`car-features/${feature.name}`" size="50" :fill="teamsiteConfig.color"></svg-icon>
      </div>
      <div class="text">
        <strong v-html="$t(`cars.features.${feature.name}`)"></strong>
        <span v-if="printableValue" v-html="translatedValue"></span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.car-feature {
  min-height: rem-calc(110);
  margin-bottom: rem-calc(20);
  font-size: rem-calc(14);
  text-align: center;

  @include breakpoint(small only) {
    padding-top: rem-calc(15);
    margin-bottom: rem-calc(15);
    min-height: 120px;
  }

  .inner {
    overflow: hidden;
    padding: 0 20px;
  }
  strong {
    font-weight: bold;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CarFeature.vue